import { Helmet } from 'react-helmet-async';
import { faqSchema } from '../data/schema';
import '../css/Faq.css';

// FAQ visible sur la page + données structurées FAQPage correspondantes
const Faq = ({ title = 'Questions fréquentes', items }) => (
    <section className="faq-section">
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(faqSchema(items))}</script>
        </Helmet>
        <h2>{title}</h2>
        <div className="faq-items">
            {items.map((item) => (
                <details key={item.question} className="faq-item">
                    <summary>{item.question}</summary>
                    <p>{item.answer}</p>
                </details>
            ))}
        </div>
    </section>
);

export default Faq;
